import script from "./TtSyncCoverItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TtSyncCoverItem.vue?vue&type=script&setup=true&lang=js"

import "./TtSyncCoverItem.vue?vue&type=style&index=0&id=6b5e818a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b5e818a"]])

export default __exports__